type EventCallback = (payload: unknown) => void;

const eventListeners = reactive(new Map<string, EventCallback[]>());

export function useEventBus() {
   function emit(event: string, payload?: unknown) {
      const callbacks = eventListeners.get(event);
      if (callbacks) {
         callbacks.forEach((callback) => callback(payload));
      }
   }

   function on(event: string, callback: EventCallback) {
      if (!eventListeners.has(event)) {
         eventListeners.set(event, []);
      }
      eventListeners.get(event)!.push(callback);
   }

   function off(event: string, callback: EventCallback) {
      const callbacks = eventListeners.get(event);
      if (callbacks) {
         eventListeners.set(
            event,
            callbacks.filter((cb) => cb !== callback),
         );
      }
   }

   return { emit, on, off };
}
